"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCAL_STORAGE_KEY = void 0;
var LOCAL_STORAGE_KEY = 'hs-rich-text';
exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;